import type { PortfolioData } from '../domain/portfolio.types';

export const fetchPortfolioData = async (): Promise<PortfolioData> => {
  // In a real app, this might be a fetch call.
  // Since we are using a local JSON file in src/assets, we can import it dynamically or fetch it if it's in public.
  // The JSON is currently at src/assets/portfolio-data.json. 
  // It's easier to just import it directly.
  const data = await import('../../../assets/portfolio-data.json');
  return data.default as PortfolioData;
};
